<template>
  <div v-if="isLoading" class="flex items-center justify-center px-16">
    <JIcon name="spinner" size="40" data-testid="spinner" />
  </div>
  <MyProfileFormFields v-else :form="formData" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { JIcon } from '@journey/ui-kit'
import MyProfileFormFields from './MyProfileFormFields/MyProfileFormFields.vue'
import useHelpStore from '@/modules/Help/store'
import { useProfileQuery } from '@/modules/Profile/requests/queries'
import { HELP_SECTIONS } from '@/modules/Core/constants'

const { data, isLoading } = useProfileQuery()

const formData = computed(() => data.value?.data)

// RECENT ACTIVITY
const helpStore = useHelpStore()

helpStore.setRecentActivity(HELP_SECTIONS.Profile)
</script>
